export default "__VITE_ASSET__BOXUwYlX__"